module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_background_image1.58625c57.svg";